import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../View.css";
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import EnhancedTable from '../../widgets/ResponsiveTable';
import EnhancedToolbar from '../../widgets/Toolbar';
import LinkDialog from "../LinkDialog";
import SearchView from "../../widgets/SearchView";
import Prompt from '../../widgets/Prompt';
import TradeSetupSearchForm from '../program/TradeSetupSearchForm';
import ViewUtils from '../../ViewUtils';
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";


const headCells = [
    { id: 'ArtisanCode', numeric: false, disablePadding: true, label: 'Artisan Code' },
    { id: 'ArtisanTitle', numeric: false, disablePadding: true, label: 'Artisan Title' },
    { id: 'ProgrammeStatus', numeric: false, disablePadding: true, label: 'Programme Status' },
    { id: 'CommencementDate', numeric: false, disablePadding: true, label: 'Commencement Date' },
    { id: 'CompletionDate', numeric: false, disablePadding: true, label: 'CompletionDate' },
    { id: 'TradeTestSerialNumber', numeric: false, disablePadding: true, label: 'Trade Test Serial Number' }
];



const utils = new ViewUtils();
const toolbarRef = React.createRef();

class LearnerTVETNCV extends Component {
    constructor(props) {
        super(props);

        //console.log(this.props.programmeId);
        this.searchParameters = !utils.isNull(this.props.location.state.learnerID) ? [
            { Name: "LearnerTVETNCVID", Value: "" },
            { Name: "ArtisanTitle", Value: "" },
            { Name: "ProgrammeID", Value: this.props.programmeId },
            { Name: "LearnerID", Value: this.props.location.state.learnerID }
        ]
            :
            [
                { Name: "LearnerTVETNCVID", Value: "" },
                { Name: "ArtisanTitle", Value: "" },
                { Name: "LearnerID", Value: this.props.location.state.learnerID }
            ];

        let model = !utils.isNull(this.props.location.state.learnerID) ?
            {
                LearnerTVETNCVID: "",
                ArtisanTitle: "",
                ProgrammeID: this.props.programmeId,
                LearnerID: this.props.location.state.learnerID

            }
            :
            {
                LearnerTVETNCVID: "",
                ArtisanTitle: "",
                LearnerID: this.props.location.state.learnerID
            }


        if (!utils.isNull(props.exclusions)) {
            model.Exclusions = props.exclusions;
            this.searchParameters.push({ Name: "Exclusions", Value: props.exclusions });
        }


        this.state =
        {
            model: model,
            keyUpSwitch: false,
            selectedLearnerTVETNCV: null,
            clearSelectedRow: false

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'view', label: '', tooltip: 'View', icon: 'ViewIcon', visible: this.props.menuPermissionItem.View, disabled: utils.isNull(this.state.selectedLearnerTVETNCV) },
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add, disabled: utils.isNull(this.state.selectedLearnerTVETNCV) },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', visible: this.props.menuPermissionItem.Edit, disabled: utils.isNull(this.state.selectedLearnerTVETNCV) },
                        { id: "delete", label: "", tooltip: "Remove programme", icon: "DeleteIcon", visible: this.props.menuPermissionItem.Delete, disabled: utils.isNull(this.state.selectedLearnerTVETNCV) },
                        { id: 'generate', label: 'Generate Agreement', icon: 'DownloadIcon', path: false, tooltip: 'Generate Agreement', visible: this.props.menuPermissionItem.Edit, disabled: utils.isNull(this.state.selectedLearnerTVETNCV) },
                        { id: 'serialno', label: 'Generate Serial Number', icon: 'ExtensionIcon', path: false, tooltip: 'Generate Serial Number', visible: this.props.menuPermissionItem.Edit && !["Provider", "Agent", "AET Agent", "Employer"].includes(utils.getCurrentRole()), disabled: utils.isNull(this.state.selectedLearnerTVETNCV) },
                        { id: 'pttr', label: 'Download PTTR', icon: 'GetAppIcon', path: false, tooltip: 'Download Pre-Trade Test Results', visible: this.props.menuPermissionItem.Edit, disabled: utils.isNull(this.state.selectedLearnerTVETNCV) },
                        { id: 'sor', label: 'Download SOR', icon: 'AssessmentIcon', path: false, tooltip: 'Download SOR', visible: this.props.menuPermissionItem.Edit, disabled: utils.isNull(this.state.selectedLearnerTVETNCV) }
                    ]
                }
            ]
        }

        //TODO: Add url for unit standard removal
        this.deleteUrl = ""
    }


    handleToolbarButtonClick = (buttonId) => {
        if ("close" === buttonId) {
            this.props.history.push({
                pathname: '/learner',
                state: {
                    selection: this.props.location.state.learnerID
                }
            });
        }
        else if (buttonId === "add") {
            this.props.history.push({
                pathname: '/AddLearnerTVETNCV',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    LearnerTVETNCVID: null,
                    hideFields: true,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem
                }
            })
        }
        else if (buttonId === "edit") {
            this.props.history.push({
                pathname: '/AddLearnerTVETNCV',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    LearnerTVETNCVID: this.state.selectedLearnerTVETNCV[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem
                }
            })
        }
        else if (buttonId === "view") {
            this.props.history.push({
                pathname: '/AddLearnerTVETNCV',
                state: {
                    LearnerID: this.props.location.state.learnerID,
                    LearnerTVETNCVID: this.state.selectedLearnerTVETNCV[0].Id,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.menuPermissionItem,
                    viewOnly: true
                }
            })
        }

        else if (buttonId === "generate") {
            this.generateDocuments();
            toolbarRef.current.setButtonDisabled("edit", true);
            toolbarRef.current.setButtonDisabled("delete", true);
            toolbarRef.current.setButtonDisabled("generate", true);
            toolbarRef.current.setButtonDisabled("serialno", true);
            toolbarRef.current.setButtonDisabled("pttr", true);
            toolbarRef.current.setButtonDisabled("sor", true);
        }

        else if (buttonId === "serialno") {
            if (!utils.isNull(this.state.selectedLearnerTVETNCV)) {
                this.generateSerialNo();
                toolbarRef.current.setButtonDisabled("edit", true);
                toolbarRef.current.setButtonDisabled("delete", true);
                toolbarRef.current.setButtonDisabled("generate", true);
                toolbarRef.current.setButtonDisabled("serialno", true);
                toolbarRef.current.setButtonDisabled("pttr", true);
                toolbarRef.current.setButtonDisabled("sor", true);
            }
            else {
                this.setState({ selectedLearnerTrade: null, clearSelectedRow: true })
            }
        }

        else if (buttonId === "pttr") {
            if (!utils.isNull(this.state.selectedLearnerTVETNCV)) {
                this.generatePTTR();
                toolbarRef.current.setButtonDisabled("edit", true);
                toolbarRef.current.setButtonDisabled("delete", true);
                toolbarRef.current.setButtonDisabled("generate", true);
                toolbarRef.current.setButtonDisabled("serialno", true);
                toolbarRef.current.setButtonDisabled("pttr", true);
                toolbarRef.current.setButtonDisabled("sor", true);
            }
            else {
                this.setState({ selectedLearnerTrade: null, clearSelectedRow: true })
            }
        }

        else if (buttonId === "sor") {
            if (!utils.isNull(this.state.selectedLearnerTVETNCV)) {
                this.generateSOR();
                toolbarRef.current.setButtonDisabled("edit", true);
                toolbarRef.current.setButtonDisabled("delete", true);
                toolbarRef.current.setButtonDisabled("generate", true);
                toolbarRef.current.setButtonDisabled("serialno", true);
                toolbarRef.current.setButtonDisabled("pttr", true);
                toolbarRef.current.setButtonDisabled("sor", true);
            }
            else {
                this.setState({ selectedLearnerTrade: null, clearSelectedRow: true })
            }
        }

    }

    generateSerialNo = () => {

        let url = "api/sims/learnerTVETNCV/GenerateSerialNumber?Id=" + this.state.selectedLearnerTVETNCV[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            this.setState({ selectedLearnerTVETNCV: null, clearSelectedRow: true, showTable: false }, () => {
                this.setState({ showTable: true })
            })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    generateDocuments = () => {

        let url = "api/sims/learnerTVETNCV/GenerateLearnerAgreement?Id=" + this.state.selectedLearnerTVETNCV[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            this.setState({ selectedLearnerTVETNCV: null, clearSelectedRow: true })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    generatePTTR = () => {

        let url = "api/sims/learnerTVETNCV/GeneratePTTR?Id=" + this.state.selectedLearnerTVETNCV[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            this.setState({ selectedLearnerTVETNCV: null, clearSelectedRow: true })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    generateSOR = () => {

        let url = "api/sims/learnerTVETNCV/GenerateSOR?Id=" + this.state.selectedLearnerTVETNCV[0].Id;
        utils.invokeUrl(url, (response) => {
            utils.showMessage(this, response.Message, response.MessageType);
            let documentInfo = JSON.parse(response.Message);
            this.FileDownload(documentInfo.OriginalFileName);
            this.setState({ selectedLearnerTVETNCV: null, clearSelectedRow: true })
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    };

    FileDownload = (documentName) => {

        utils.invokeUrl("api/sims/learnerTVETNCV/DownloadLearnerAgreement?FileName=" + documentName, (response) => {

            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
        }, (e) => {
            this.setState({ messsageAlert: utils.SYSTEM_ERROR_MESSAGE, messageStyle: "outlinedError" });
        }
        );

    };

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {

            this.setState({ selectedLearnerTVETNCV: selection })

            if (selection[0].ProgrammeStatus === "Completed") {
                toolbarRef.current.setButtonDisabled("delete", true)
            }
            else {
                toolbarRef.current.setButtonDisabled("delete", false)
            }

            let url = "api/sims/LearnerTVETNCV/CheckCanEditProgramme?Id=" + selection[0].Id;
            utils.invokeUrl(url, (response) => {
                toolbarRef.current.setButtonDisabled("edit", response.Result === "0" ? true : false)
                if (selection[0].ProgrammeStatus === "Completed" || selection[0].ProgrammeStatus === "Registered") {
                    toolbarRef.current.setButtonDisabled("delete", true)
                }
                else {
                    toolbarRef.current.setButtonDisabled("delete", false)
                }
                if (selection[0].ProgrammeStatus === "Completed") {
                    toolbarRef.current.setButtonDisabled("sor", false)
                }
                else {
                    toolbarRef.current.setButtonDisabled("sor", true)
                }
                if (utils.getCurrentRole() === "Provider" || utils.getCurrentRole() === "Agent" || utils.getCurrentRole() === "Employer" || utils.getCurrentRole() === "AET Agent" || selection[0].ProgrammeStatus !== "Registered") {
                    toolbarRef.current.setButtonDisabled("serialno", true)
                }
                else {
                    toolbarRef.current.setButtonDisabled("serialno", false)
                }
                if (selection[0].ProgrammeStatus === "Completed" || selection[0].ProgrammeStatus === "Registered") {
                    toolbarRef.current.setButtonDisabled("pttr", false)
                }
                else {
                    toolbarRef.current.setButtonDisabled("pttr", true)
                }
            },
                (e) => {
                    toolbarRef.current.setButtonDisabled("edit", true)
                },
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    }
                }
            )
            //toolbarRef.current.setButtonDisabled("sor", false)
        }
        else {
            this.setState({ selectedLearnerTVETNCV: null })
            toolbarRef.current.setButtonDisabled("edit", true)
            toolbarRef.current.setButtonDisabled("sor", true)
        }
    }


    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    onClearSelectedRow = () => {
        this.setState({ clearSelectedRow: false });
    }

    render() {
        return (
            <ViewContainer mode={this.props.mode} title="">
                <p className="breadcrumbs">
                    {`Learner > TVET NCV Support > ${this.props.location.state.learnerNames}`}
                </p>
                <SearchView headCells={headCells} dataUrl={utils.isNull(this.props.dataUrl) ? "api/sims/learnerTVETNCV/GetLearnerTVETNCVSearch" : this.props.dataUrl}
                    deleteUrl={"api/sims/learnerTVETNCV/unlinkLearnerTVETNCV"} useDeletePost={true}
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    toolbarRef={toolbarRef}
                    searchParameters={this.searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="ArtisanTitle" mode={this.props.mode}
                    history={this.props.history} multiSelect={this.props.multiSelect}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    keyUpSwitch={this.state.keyUpSwitch}
                    setSelection={(selection) => { this.handleSelection(selection) }}
                    promptTitle={"Remove Learner TVET NCV Support Programme"}
                    promptContent={"Are you sure you want to remove the learner TVET NCV Support Programme record?"} clearSelectedRow={this.state.clearSelectedRow} onClearSelectedRow={this.onClearSelectedRow}
                >
                    <TradeSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(LearnerTVETNCV));

